/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const orderTransactionsDirective = require('./orderTransactionsDirective');

const orderTransactionsModule = angular
    .module('enervee_utils.orderTransactions', [])
    .directive('orderTransactions', orderTransactionsDirective);

module.exports = orderTransactionsModule;